import FR from "@/i18n/fr.json";

const ATTRS = ["placeholder", "alt", "aria-label", "title"];
const norm = (s) => s.replace(/\s+/g, " ").trim();

const tText = (n) => {
  const raw = n.nodeValue;
  const v = raw && FR[norm(raw)];
  if (v) n.nodeValue = raw.match(/^\s*/)[0] + v + raw.match(/\s*$/)[0];
};

const tAttrs = (el) => {
  ATTRS.forEach((a) => {
    const v = el.getAttribute(a);
    const tr = v && FR[norm(v)];
    if (tr) el.setAttribute(a, tr);
  });
};

const walk = (root) => {
  if (root.nodeType === 3) return tText(root);
  if (root.nodeType !== 1 || root.closest("[data-no-translate]")) return;
  tAttrs(root);
  const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  for (let n = w.nextNode(); n; n = w.nextNode()) {
    if (n.nodeType === 3) tText(n);
    else tAttrs(n);
  }
};

export const startTranslator = () => {
  walk(document.body);
  const obs = new MutationObserver((ms) => {
    ms.forEach((m) => {
      if (m.type === "characterData") tText(m.target);
      else if (m.type === "attributes") tAttrs(m.target);
      else m.addedNodes.forEach(walk);
    });
  });
  obs.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  return () => obs.disconnect();
};
